;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  window.eah.log = function () {
    try {
      console.log.apply(console, arguments)
    } catch (e) {}
  }

  window.eah.common = (function () {
    let pub = {}

    pub.init = function () {
      setupNav()
      setupDesktopNav()
      setupTextArea()
      scrollNav()
    }

    function setupNav () {
      const $subNavItems = $('.spmenu-vertical li.menu-item-has-children > a')
      const $pushMenu = $('.toggle-menu')

      $pushMenu.jPushMenu()
      $subNavItems.on('click', function (e) {
        e.preventDefault()

        const $this = $(this)
        // const $nav = $this.parents('nav')
        // const $secondaryNav = $('#spmenu-subnav')
        const $subNav = $this.siblings('ul')
        // const $parent = $subNav.parent('li.menu-item')
        const $childrenNav = $subNav.find('.sub-nav')
        const $childrenLinks = $subNav.find('a')

        // add a selected class to change styles
        $this.toggleClass('selected')
        // slide the child <ul> up or down
        $subNav.slideToggle()
        // close any children <ul> so that menu opens in default state
        $childrenLinks.removeClass('selected')
        $childrenNav.slideUp()
      })
    } // end setupNav

    function setupDesktopNav () {
      $('.nav--desktop .spmenu-vertical li.menu-item-has-children').hover(
        function (e) {
          $(this).find('.sub-menu').slideDown()
        },
        function (e) {
          $(this).find('.sub-menu').slideUp()
        }
      )
    }

    const $container = $('#container')

    function toggleNavClass () {
      // console.log('toggleNavClass')
      const topP = window.pageYOffset // $(document).scrollTop()
      if (topP > 20) {
        $container.addClass('is-stuck')
      } else if (topP < 20) {
        $container.removeClass('is-stuck')
      }
    }

    // grow/shrink nav on scroll
    function scrollNav () {
      $(window).on('scroll', toggleNavClass) //  _.debounce(toggleNavClass, 50, true))
    } // end scrollNav

    // placeholder text support for textarea elements within the ninja forms
    function setupTextArea () {
      const $textArea = $('form.ninja-forms-form').find('textarea')
      const $value = $textArea.val()

      $textArea.data('defaultValue', $value)

      $textArea.focus(function () {
        const $this = $(this)
        const val = $this.val()
        if (val === $this.data('defaultValue')) {
          $this.val(' ')
        }
      })

      $textArea.blur(function () {
        const $this = $(this)
        const val = $this.val().toString()

        if (!val.match(/[a-zA-Z]/g)) {
          $this.val($this.data('defaultValue'))
        }
      })
    } // end setupTextArea

    pub.browserWarning = function () {
      // if cookie is set, just return
      if ($.cookie('unsupported_ie') === undefined) {
        // show the message
        $.fancybox($('#unsupported_ie'), {
          width: '70%',
          height: '70%'
        })

        // Set the cookie
        $.cookie('unsupported_ie', 'true', { expires: 365, path: '/' })
      }
    }
    pub.autoLoad = []

    // https://developer.mozilla.org/en-US/docs/Web/API/URLUtils/search
    pub.urlParams = new (function (sSearch) { // eslint-disable-line no-extra-parens
      if (sSearch.length > 1) {
        for (let aItKey, nKeyId = 0, aCouples = sSearch.substr(1).split('&'); nKeyId < aCouples.length; nKeyId++) {
          aItKey = aCouples[ nKeyId ].split('=')
          this[ decodeURIComponent(aItKey[ 0 ]) ] = aItKey.length > 1 ? decodeURIComponent(aItKey[ 1 ]) : ''
        }
      }
    })(window.location.search)

    // return all public methods
    return pub
  })()

  $(function () {
    eah.common.init()
  })
})(jQuery, window)
